import createIcon from '../../createIcon';

/**
 * @component @name BreakfastDining
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE4IDNINkMzLjc5IDMgMiA0Ljc5IDIgN0MyIDguNDggMi44MSA5Ljc1IDQgMTAuNDVWMTlDNCAyMC4xIDQuOSAyMSA2IDIxSDE4QzE5LjEgMjEgMjAgMjAuMSAyMCAxOVYxMC40NUMyMS4xOSA5Ljc2IDIyIDguNDggMjIgN0MyMiA0Ljc5IDIwLjIxIDMgMTggM1pNMTQgMTVIMTBWMTFIMTRWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BreakfastDining = createIcon('BreakfastDining', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18 3H6C3.79 3 2 4.79 2 7C2 8.48 2.81 9.75 4 10.45V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V10.45C21.19 9.76 22 8.48 22 7C22 4.79 20.21 3 18 3ZM14 15H10V11H14V15Z',
      key: '1mvnwa',
    },
  ],
]);

export default BreakfastDining;
